import GroupItem from './group-item';
import EmptyItem from './empty-item';

var PageGroup = React.createClass({
  render: function(){
    var that = this;
    var places = this.props.group.items;
    var items = [];
    var index = this.props.index;
    var title =  this.props.group.name;

    places.forEach(function(place, i){
      //TODO: this is super hacky, replace with something else
      if (title === "Expert Trip Ideas") place.bucket = 'trip-ideas';

      var itemIndex = places[0].bucket === "guides" ? i - 1 : i;
      items.push(<GroupItem key={i} item={place} groupIndex={index} itemIndex={itemIndex + (that.props.itemOffset || 0)} weekday={that.props.group.weekday} isSmallScreen={that.props.isSmallScreen} autoImageUrls={ that.props.autoImageUrls } />);
    });
    if (items.length === 0) {
      items.push(<EmptyItem />);
    }
      
    var date = this.props.useRelativeDate ? "Day " + ( index + 1 ) : title;

    return (
      <div className="day">
        <h2 className='group-header'>
          <i className={"icon " + this.props.group.icon} ></i>{date}
        </h2>
        <div className="items">
          { items }
        </div>
      </div>
    );
  }
});

module.exports = PageGroup;


// WEBPACK FOOTER //
// ./components/guide-components/page-group.js